import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import _size from 'lodash/size';
import { EMPTY_ARRAY } from '@tekion/tekion-base/app.constants';
import { ALL_OPTION } from './withSelectAllOptions.constants';
export var checkIfAllOptionsSelected = function checkIfAllOptionsSelected(options, selectedValues) {
  return _size(selectedValues) === _size(options);
};
var makeAllOption = function makeAllOption(areAllOptionsSelected) {
  return areAllOptionsSelected ? _objectSpread(_objectSpread({}, ALL_OPTION), {}, {
    label: __('Deselect All')
  }) : ALL_OPTION;
};
export var getOptions = function getOptions(options, selectedValues) {
  var areAllOptionsSelected = checkIfAllOptionsSelected(options, selectedValues);
  var allOption = makeAllOption(areAllOptionsSelected);
  return [allOption].concat(_toConsumableArray(options));
};
export var getSelectedValuesWithAll = function getSelectedValuesWithAll(options, selectedValues) {
  var areAllOptionsSelected = checkIfAllOptionsSelected(options, selectedValues);
  return areAllOptionsSelected ? [].concat(_toConsumableArray(selectedValues || EMPTY_ARRAY), [ALL_OPTION.value]) : selectedValues;
};

/**
 * @description This function is used for determining if we should show Select All as indeterminate checkbox.
 * @param {*} options select options
 * @param {*} selectedValues values which are selected
 */
var shouldShowIndeterminateAllOption = function shouldShowIndeterminateAllOption(options, selectedValues) {
  return _size(selectedValues) > 0 && _size(selectedValues) !== _size(options);
};

/**
 * @description This would return a list of options for which we have to show indeterminate checkboxes
 */
export var getIndeterminateOptions = function getIndeterminateOptions(options, selectedValues) {
  return shouldShowIndeterminateAllOption(options, selectedValues) ? [ALL_OPTION.value] : EMPTY_ARRAY;
};